import { Box, Modal } from '@mui/material';
import usePermissionForUser from 'components/hooks/permissions/usePermissionForUser';
import React, { memo, useMemo } from "react";
import styled from "styled-components";
import { closeModal } from "utils/assets/images";
import TranscriptWithAudio from '../transcriptWithAudio/transcriptWithAudio';
const style={}

const LearnModalBg = styled.div`
    background: white;
    max-width: 383px;
    margin: 0 auto;
    margin-top: 115px;
    border-radius: 9px;
    padding: 55px 42px; !important;
    @media screen and (max-width: 600px) {
       padding:55px 14px; !important;
    }
`;

const ModelDtl = styled.div`
    box-shadow: none;
`;

const DefaultAudioPlayer = ({ openAudioPlayer, handleClose, audio,from }) => {
  return (
    <Modal open={openAudioPlayer} onClose={handleClose} className={`${from ===  "slideWidget" ? "audio-player-canvas" : ""}`}>
      <Box sx={style} className="modelCntntIner modalVideoPlay audioMOdalSection">
        <LearnModalBg className="lernModalBg AudioContainerNon">
          <ModelDtl  className="modelDtl">
            <div
              style={{ zIndex: 70, top: "-64px",right: "-50px" }}
              className="closeModelInfo closeVideoModal closIcns"
              onClick={handleClose}
            >
              <img
                style={{ height: "30px" }}
                src={closeModal}
                onClick={handleClose}
              />
            </div>
            <TranscriptWithAudio audioUrl={audio}>
              <audio
                controls
                controlsList={"nodownload"}
                src={audio}
                style={{ height: "40px" }}
              />
            </TranscriptWithAudio>
          </ModelDtl>
        </LearnModalBg>
      </Box>
    </Modal>
  );
};

export default memo(DefaultAudioPlayer);
